export interface TaksitTabloHeader {
    text: string;
    value: string;
    sortable?: boolean;
    width?: number;
    align?: string;
}

/** Klasik taahhüt belgesi kolon sırası (Taksit/Taahhüt listesi ve döküm). */
export const TAKSIT_TABLO_HEADERS: TaksitTabloHeader[] = [
    {text: 'Taksit No', value: 'index', sortable: false},
    {text: 'Gün', value: 'faiz_isleyen_gun', sortable: false},
    {text: 'Tarih', value: 'tarih'},
    {text: 'Faiz İşletilecek Tutar', value: 'faiz_isletilecek_tutar', sortable: false},
    {text: 'İşleyen Faiz', value: 'isleyen_faiz', sortable: false},
    {text: 'BSMV', value: 'isleyen_faiz_bsmv', sortable: false},
    {text: 'Toplam Faiz', value: 'toplam_faiz', sortable: false},
    {text: 'Kalan Ana Para', value: 'kalan_ana_para', sortable: false},
    {text: 'Toplam Borç', value: 'toplam_borc', sortable: false},
    {text: 'Kalan Borç', value: 'kalan_borc', sortable: false},
    {text: 'Tahsil Harcı', value: 'tahsil_harci', sortable: false},
    {text: 'Taksit Miktarı', value: 'tutar', sortable: false},
];

/** PDF kolon göreli genişlikleri (TAKSIT_TABLO_HEADERS sırasıyla). */
export const TAKSIT_TABLO_PDF_KOLON_AGIRLIK: number[] = [
    7, 6, 12, 17, 14, 10, 13, 15, 15, 15, 12, 15,
];

/** PDF’te tek/iki satıra sığan başlık metinleri. */
export const TAKSIT_TABLO_PDF_BASLIK: Record<string, string> = {
    index: 'Taksit No',
    faiz_isleyen_gun: 'Gün',
    tarih: 'Tarih',
    faiz_isletilecek_tutar: 'Faiz İşl.\nTutar',
    isleyen_faiz: 'İşleyen\nFaiz',
    isleyen_faiz_bsmv: 'BSMV',
    toplam_faiz: 'Toplam\nFaiz',
    kalan_ana_para: 'Kalan\nAna Para',
    toplam_borc: 'Toplam\nBorç',
    kalan_borc: 'Kalan\nBorç',
    tahsil_harci: 'Tahsil\nHarcı',
    tutar: 'Taksit\nMiktarı',
};

/** Satır bazlı tutar alanları (taksitler[i].*). Kök yanıttaki toplam_borc burada değil. */
export const TAKSIT_TABLO_TUTAR_ALANLARI: string[] = [
    'faiz_isletilecek_tutar',
    'isleyen_faiz',
    'isleyen_faiz_bsmv',
    'toplam_faiz',
    'kalan_ana_para',
    'toplam_borc',
    'kalan_borc',
    'tahsil_harci',
    'tutar',
];
